<script setup lang="ts">
const props = withDefaults(defineProps<{
  modelValue?: boolean
  label?: string
  disabled?: boolean
  color?: string
  hideDetails?: boolean
  errorMessages?: string | string[]
  density?: 'default' | 'comfortable' | 'compact'
  indeterminate?: boolean
}>(), {
  density: 'default',
})

const emit = defineEmits<{
  'update:modelValue': [val: boolean]
}>()

function toggle() {
  if (!props.disabled) emit('update:modelValue', !props.modelValue)
}
</script>

<template>
  <label class="m-checkbox" :class="[`m-checkbox--${density}`, { 'm-checkbox--disabled': disabled }]" @click.prevent="toggle">
    <span class="m-checkbox__box" :class="{ 'm-checkbox--checked': modelValue, 'm-checkbox--indeterminate': indeterminate }">
      <MIcon v-if="modelValue" icon="check" size="x-small" color="white" />
      <span v-else-if="indeterminate" class="m-checkbox__dash" />
    </span>
    <span v-if="label || $slots.default" class="m-checkbox__label">
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>

<style scoped>
.m-checkbox {
  display: inline-flex;
  align-items: center;
  gap: var(--m-space-2);
  cursor: pointer;
  user-select: none;
}

.m-checkbox--compact { gap: var(--m-space-1); }

.m-checkbox__box {
  width: 20px;
  height: 20px;
  border: 2px solid var(--m-border);
  border-radius: var(--m-radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--m-transition-fast);
  flex-shrink: 0;
}

.m-checkbox--checked {
  background: var(--m-primary);
  border-color: var(--m-primary);
}

.m-checkbox--indeterminate {
  background: var(--m-primary);
  border-color: var(--m-primary);
}

.m-checkbox__dash {
  width: 10px;
  height: 2px;
  background: #fff;
}

.m-checkbox__label {
  font-size: var(--m-font-size-sm);
  color: var(--m-on-surface);
}

.m-checkbox--disabled { opacity: 0.5; pointer-events: none; }
</style>
